import { Guid } from "client_legacy/ndaw/guid";
import { environmentHttpClient } from "client/Api/httpClient";

export type GroupModel = {
	id: Guid;
	title: string;
};

export function getGroups(): Promise<GroupModel[]> {
	return environmentHttpClient.get<GroupModel[]>(
		"PowerBi/GetGroups"
	);
}

export type DashboardModel = {
	id: Guid;
	title: string;
	embedUrl: string;
	groupId: Guid | null;
};

export function getDashboards(groupId?: Guid | nil): Promise<DashboardModel[]> {
	return environmentHttpClient.get<DashboardModel[]>(
		`PowerBi/GetDashboards/${groupId ?? ""}`
	);
}

export type TokenInfo = {
	token: string;
	type: TokenType;
};

const enum TokenType {
	IdentityAuthority = 0,
	Embed = 1
}

export type TileModel = {
	id: Guid;
	dashboardId: Guid;
	title: string;
	tokenInfo: TokenInfo;
};

export function getTiles(dashboardId: Guid): Promise<TileModel[]> {
	return environmentHttpClient.get<TileModel[]>(
		`PowerBi/GetTiles/${dashboardId}`
	);
}
